export const objectOptionsList = [{ id: 1, text: 'one' }, { id: 2, text: 'two' }, { id: 3, text: 'three' }]

export const iconOptionsList = [
  {
    text: 'item1',
    id: 0,
    value: 0,
    icon: 'fa fa-address-book',
  },
  {
    text: 'item2',
    id: 1,
    value: 1,
    icon: 'fa fa-android',
  },
  {
    text: 'item2',
    id: 2,
    value: 2,
    icon: 'fa fa-android',
  },
  {
    text: 'item2',
    id: 3,
    value: 3,
  },
  {
    text: 'item2',
    id: 4,
    value: 4,
    icon: 'fa fa-android',
  },
]
